export class State {
  name: string;
  abbreviation: string;
  sortOrder: number;
}
export class StateCodeCheck {
  stateCode: string;
  lineOfBusiness: string;
}